import styles from '@/styles/Info.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getPageTitle } from '@/utils/helpers'
import { useTranslation } from 'next-i18next'
import Raw from '@/components/common/Raw/Raw'
import { Roboto } from "next/font/google"
import GDPRSwedish from './GDPRSwedish'
import GDPREnglish from './GDPREnglish'

const roboto = Roboto({
  subsets: ['latin'],
  weight: ['300'],
})

type Props = {}

const Contact = (props: Props) => {
  const { t, i18n } = useTranslation('privatepolicy')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('title'))}</title>
      </Head>
      <main className={styles.info}>
        <h1>{t('gdpr')}</h1>
        {i18n.language === 'sv' && (
          <GDPRSwedish
            className={roboto.className}
          />
        )}
        {i18n.language === 'en' && (
          <GDPREnglish
            className={roboto.className}
          />
        )}
        <h2>{t('cookies')}</h2>
        <Raw
          content={t('cookiesText')}
          className={roboto.className}
        />
      </main>
    </BaseLayout>
  )
}

export default Contact

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'privatepolicy',
      'footer',
    ])),
  },
})